import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  return (
    <footer className="app-footer">
      <Container>
        <Row>
          <Col className="text-center">
            <div className="footer-content">
              <div className="footer-brand mb-2">
                <i className="fas fa-store me-2"></i>
                <span className="brand-name">FreshMart Store</span>
              </div>
              <p className="footer-copyright mb-0">
                &copy; {new Date().getFullYear()} Alvin Bregana, Reagan Sajulga.
                All rights reserved.
              </p>
              <div className="footer-links mt-2">
                <span className="footer-link">Privacy Policy</span>
                <span className="footer-divider">•</span>
                <span className="footer-link">Terms of Service</span>
                <span className="footer-divider">•</span>
                <span className="footer-link">Contact Us</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
